<script setup lang="ts">
import Button from '@components/global/button.vue'
</script>

<template>
	<section class="container">
		<div class="flex w-full flex-col items-center">
			<div class="flex flex-col items-center gap-8 text-center text-default lg:w-[30%]">
				<div class="d2 relative flex uppercase text-default">
					<span class="font-heading-light">s</span>
					<span class="font-heading">to</span>
					<span class="font-heading-bold">ryte</span>
					<span class="font-heading">llin</span>
					<span class="font-heading-light">g</span>
					<div class="storytelling-border" />
				</div>
				<p class="md">The ETHER story is currently being built. Four out of five main characters have been revealed. They were co-created with their respective owners, which we had never met or spoken to prior.</p>
				<p class="md">We believe that everyone has a story to tell, and we aim to be the pen, the brush or the tool to bring those desires and ideas to life.</p>
				<Button :to="{ name: 'story', hash: '#' }" class="default" icon="fa-solid fa-arrow-up-right">
					<div type="medium">explore story</div>
				</Button>
			</div>
		</div>
	</section>
	<div class="relative w-full">
		<img src="https://cdn.projectether.co/images/home-page/home-storytelling.jpg" alt="Storytelling Section Background" class="w-full" />
		<img src="https://cdn.projectether.co/images/home-page/home-storytelling-line.svg" alt="Storytelling Section Accents" class="absolute bottom-0 left-0 hidden w-full lg:bottom-[-5%] lg:block" />
	</div>
</template>

<style scoped>
.storytelling-border {
	@apply absolute right-[-2rem] top-[-2rem] hidden h-20 w-60 rounded-tr-[16px] border-r border-t border-r-default border-t-default lg:block;
}

.storytelling-border::after {
	position: absolute;
	top: 16px;
	right: 16px;
	content: '';
	display: block;
	width: 3px;
	height: 3px;
	background: #9e76b2;
}
</style>
